<template>
  <div>
    <b-card no-body>
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->

          <!-- Search -->
          <b-col cols="12" md="6" lg="4">
            <form v-on:submit.prevent="handSearch">
              <div class="d-flex align-items-center justify-content-end">
                <b-form-input
                  v-model.trim="searchQuery"
                  @keyup.enter="handSearch()"
                  class="d-inline-block round"
                  :placeholder="$t('textPlaceholderSearchUserApproveRegister')"
                />
              </div>
            </form>
          </b-col>
          <b-col cols="12" md="4" lg="4" xl="4" class="p-0 m-1 m-md-0">
            <b-button
              variant="primary"
              :disabled="searchQuery ? false : true"
              @click="handSearch"
              class="w-full round px-lg-5"
            >
              {{ $t("search") }}
            </b-button>
          </b-col>
        </b-row>
      </div>
      <b-table responsive hover :items="items" fixed :fields="fields">
        <template #table-colgroup="scope">
          <col
            v-for="field in scope.fields"
            :key="field.key"
            :style="{
              width:
                field.key === 'org_company_name'
                  ? '320px'
                  : field.key === 'email'
                  ? '300px'
                  : ' 140px',
            }"
          />
        </template>

        <template #cell(user_sale_name)="row">
          {{ row.item.user_sale_name ? row.item.user_sale_name : "N/A" }}
        </template>
        <template #cell(actions)="row">
          <b-button
            v-b-tooltip.hover.top="$t('approvedInformation')"
            variant="primary"
            size="sm"
            @click="Edit(row.item)"
          >
            <feather-icon icon="EditIcon" />
          </b-button>
          <b-button
            v-b-tooltip.hover.top="$t('deleteRegister')"
            variant="danger"
            size="sm"
            @click="Delete(row.item, row.index, $event.target)"
          >
            <feather-icon icon="DeleteIcon" />
          </b-button>
        </template>
      </b-table>
      <b-row class="pl-2 pr-2 pb-1 pt-1 border-top">
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <label>{{ $t("showing") }}</label>
          <v-select
            v-model="perPage"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="perPageOptions"
            :clearable="false"
            style="min-width: 60px"
            class="per-page-selector select-size-sm d-inline-block ml-50 mr-1"
          />
          <label>{{ $t("entries") }}</label>
        </b-col>
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-end mb-1 mb-md-0"
        >
          <b-pagination
            v-model="currentPage"
            :per-page="perPage"
            :total-rows="totalRows"
          />
        </b-col>
      </b-row>
    </b-card>
    <b-modal
      id="modal-edit"
      size="xl"
      no-close-on-backdrop
      :title="modal_title"
      @ok="handleOk"
    >
      <h6 class="my-1 font-weight-bold">
        {{ $t("customerInformationRegistered") }}
      </h6>

      <b-row>
        <b-col cols="6">
          <b-form-group :label="$t('companyName')">
            <b-form-input
              disabled
              v-model="currentItem.org_company_name"
              placeholder="Contact name"
            />
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group :label="$t('taxCode')">
            <b-form-input
              disabled
              v-model="currentItem.org_tax_code"
              placeholder="Contact name*"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group :label="$t('address')">
            <b-form-textarea
              disabled
              v-model="currentItem.org_company_address"
              placeholder="Contact name*"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <validation-observer ref="simpleRules">
        <h6 class="my-1 font-weight-bold">
          {{ $t("customerInformationApprove") }}
        </h6>

        <b-row>
          <b-col cols="12">
            <validation-provider
              :name="$t('companyName')"
              #default="{ errors }"
              :rules="{ required: 'required', vselect: true }"
            >
              <b-form-group :state="errors.length > 0 ? false : null">
                <label
                  >{{ $t("companyName") }}<span class="required">* </span>
                  <b-icon
                    v-show="
                      currentItem.company_name == '' ||
                      currentItem.org_tax_code == ''
                        ? false
                        : true
                    "
                    @click="addNewCompany"
                    icon="plus-circle"
                    variant="success"
                    id="tooltip-button-not-interactive"
                  ></b-icon>
                  <b-tooltip
                    target="tooltip-button-not-interactive"
                    placement="bottom"
                    >{{ $t("addCompany") }}</b-tooltip
                  >
                </label>

                <Select4
                  v-model="currentItem.company_name"
                  :class="errors.length > 0 ? 'is-invalid' : null"
                  placeholder="Select Company"
                  @select="
                    ({ tms_id, fast_id }) => {
                      (currentItem.companyTmsId = tms_id),
                        (currentItem.companyFastId = fast_id);
                    }
                  "
                  :options="{
                    isSearch: true,
                    value: 'name',
                    label: 'text',
                    all: true,
                    data: companyItems,
                    fields: [
                      { field: 'code', label: 'Tax Code' },

                      { field: 'name', label: 'Name' },
                      {
                        field: 'acronym',
                        label: 'Acronym',
                      },
                    ],
                  }"
                />

                <small v-show="errors.length > 0" class="text-danger">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="4">
            <validation-provider
              :name="$t('Customer Level')"
              #default="{ errors }"
              :rules="{ required: 'required', vselect: true }"
            >
              <b-form-group :state="errors.length > 0 ? false : null">
                <label
                  >{{ $t("Customer Level") }}<span class="required">*  </span>
                </label>

                <Select4
                  v-model="currentItem.customerLevelId"
                  :class="errors.length > 0 ? 'is-invalid' : null"
                  placeholder="Select VIP"
                  :options="{
                    value: 'name',
                    label: 'text',
                    all: true,
                    data: vip_types,
                    fields: [
                      { field: 'name', label: 'Name' },
                      { field: 'description', label: 'Description' },
                    ],
                  }"
                />

                <small v-show="errors.length > 0" class="text-danger">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="4">
            <validation-provider
              :name="$t('contactName')"
              #default="{ errors }"
              rules="required"
            >
              <b-form-group>
                <label
                  >{{ $t("contactName") }}<span class="required">*</span>
                </label>

                <b-form-input
                  v-model="currentItem.full_name"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="$t('contactName')"
                />
                <small v-show="errors.length > 0" class="text-danger">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="4">
            <b-form-group>
              <label>{{ $t("gender") }}<span class="required">*</span> </label>

              <b-row class="pw-1">
                <b-col cols="4">
                  <b-form-radio
                    v-model="currentItem.gender_id"
                    name="some-radios"
                    value="1"
                  >
                    {{ $t("Male") }}
                  </b-form-radio>
                </b-col>
                <b-col cols="4">
                  <b-form-radio
                    v-model="currentItem.gender_id"
                    name="some-radios"
                    value="2"
                  >
                    {{ $t("Female") }}
                  </b-form-radio>
                </b-col>
              </b-row>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="4">
            <validation-provider
              :name="$t('phone')"
              #default="{ errors }"
              rules="required|regex:^([0-9]+)$"
            >
              <b-form-group>
                <label>{{ $t("phone") }}<span class="required">*</span> </label>
                <b-form-input
                  v-model="currentItem.phone"
                  :state="errors.length > 0 ? false : null"
                />
                <small v-show="errors.length > 0" class="text-danger">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="4">
            <validation-provider
              :name="$t('email')"
              #default="{ errors }"
              rules="required|email"
            >
              <b-form-group>
                <label>{{ $t("email") }}<span class="required">*</span> </label>

                <b-form-input
                  :state="errors.length > 0 ? false : null"
                  v-model="currentItem.email"
                  :placeholder="$t('email')"
                />
                <small v-show="errors.length > 0" class="text-danger">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="4">
            <validation-provider
              :name="$t('userName')"
              #default="{ errors }"
              rules="required|username"
            >
              <b-form-group>
                <label
                  >{{ $t("userName") }}<span class="required">* </span>
                </label>

                <b-form-input
                  :state="errors.length > 0 ? false : null"
                  v-model.trim="currentItem.user_id"
                />
                <small v-show="errors.length > 0" class="text-danger">{{
                  errors[0] == "invalidUser" ? $t("invalidUser") : errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <validation-provider
              :name="$t('wr1Staff')"
              #default="{ errors }"
              :rules="{ required: 'required', vselect: true }"
            >
              <b-form-group :state="errors.length > 0 ? false : null">
                <label
                  >{{ $t("wr1Staff") }} <span class="required">*</span>
                </label>
                <div class="d-flex">
                  <b-button
                    @click="$bvModal.show('modal-add-sale')"
                    variant="gradient-success"
                    class="btn-icon mr-1 text-white"
                  >
                    <feather-icon icon="UserPlusIcon" />
                  </b-button>

                  <SelectMultiple
                    :classProp="errors.length > 0 ? 'is-invalid' : null"
                    v-model="currentItem.sale_name"
                    :options="{
                      value: 'code',
                      all: true,
                      data: sales,
                      multiple: true,
                      allowClear: true,
                    }"
                  />
                </div>

                <small v-show="errors.length > 0" class="text-danger">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>
      </validation-observer>
      <template #modal-footer>
        <b-button
          variant="secondary"
          size="sm"
          class="round"
          @click="$bvModal.hide('modal-edit')"
        >
          {{ $t("cancel") }}
        </b-button>
        <b-button variant="primary" size="sm" @click="handleOk" class="round">
          {{ $t("approved") }}
        </b-button>
      </template>
    </b-modal>

    <b-modal
      id="modal-add-sale"
      size="lg"
      no-close-on-backdrop
      title="Add Service"
      @ok="handleOk"
    >
      <h5 class="my-1 font-weight-bold card-text text-primary">
        Chọn loại hình dịch vụ để gán sale cho khách hàng
      </h5>
      <b-row>
        <b-col cols="12">
          <div class="float-left">
            <b-dropdown
              variant="link"
              toggle-class="text-decoration-none p-0 mb-1 text-primary"
              no-caret
            >
              <template v-slot:button-content>
                <b-button
                  @click="$bvModal.show('modal-add-sale')"
                  variant="gradient-success"
                  class="btn-icon mr-1 text-white"
                >
                  <feather-icon icon="PlusIcon" /> Add Service
                </b-button>
              </template>
              <b-dropdown-item
                @click="services.push(i)"
                :key="i.id"
                v-for="i in service_types.filter(
                  (i) => services.filter((j) => j.id === i.id).length == 0
                )"
              >
                <feather-icon icon="FolderIcon" class="mr-50" />
                <span>{{ i.name }}</span>
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </b-col>
        <b-col class="col-12">
          <b-row>
            <b-col v-for="(item, index) in services" :key="index" cols="12">
              <b-form-group>
                <label>{{ item.name }}</label>
                <SelectMultiple
                  :ref="camelCaseText(item.name)"
                  v-model="serviceUserID[item.id]"
                  :options="{
                    value: 'code',
                    all: true,
                    data: sales,
                    multiple: true,
                    allowClear: true,
                  }"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <template #modal-footer>
        <b-button
          variant="secondary"
          size="sm"
          class="round"
          @click="$bvModal.hide('modal-add-sale')"
        >
          {{ $t("cancel") }}
        </b-button>
        <b-button
          variant="primary"
          size="sm"
          @click="handleOkAddSale"
          class="round"
        >
          {{ $t("approved") }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { camelCase } from "lodash";
import Select2 from "v-select2-component";

import vSelect from "vue-select";
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BTooltip,
  BModal,
  BFormCheckbox,
  BFormGroup,
  VBTooltip,
  BInputGroupAppend,
} from "bootstrap-vue";
import useJwt from "@/auth/jwt/useJwt";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Ripple from "vue-ripple-directive";
import { mapState, mapActions } from "vuex";

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    vSelect,
    FeatherIcon,
    BModal,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    Select2,
    BInputGroupAppend,
  },
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  computed: {
    ...mapState("masterData", [
      "companyItems",
      "sales",
      "service_types",
      "vip_types",
    ]),
  },
  mounted() {
    this.fetchUser();
    this.fetchCompany();
    this.fetchSaler();
    this.fetchServiceTypes();
    this.fetchVip();
  },
  watch: {
    perPage: function (n, o) {
      this.fetchUser();
    },
    searchQuery: function (n, o) {
      if (this.searchQuery == "") {
        this.fetchUser();
      }
    },
    currentPage: function (n, o) {
      this.fetchUser();
    },
    "$i18n.locale": function (newVal, oldVal) {
      this.renderComponent = false;
      this.fields = [];
      this.$nextTick(() => {
        // Add the component back in
        this.fields = [
          {
            key: "created_date",
            sortable: true,
            label: this.$i18n.t("date"),
            class: "maxw-100",
          },
          {
            key: "org_company_name",
            sortable: false,
            label: this.$i18n.t("companyName"),
          },
          {
            key: "full_name",
            label: this.$i18n.t("contactName"),
            sortable: false,
          },
          {
            key: "phone",
            label: this.$i18n.t("phone"),
            sortable: false,
          },
          {
            key: "email",
            label: this.$i18n.t("email"),
            sortable: false,
          },
          {
            key: "user_sale_name",
            label: this.$i18n.t("saler"),
            sortable: false,
          },
          {
            key: "creator",
            sortable: false,
            label: this.$i18n.t("creator"),
          },
          {
            key: "actions",
            label: this.$i18n.t("actions"),
            thClass: "text-center",
            tdClass: "actions-td",
          },
        ];

        this.renderComponent = true;
      });
    },
  },
  methods: {
    handleOkAddSale() {
      this.currentItem.sale_name = [];
      console.log(this.serviceUserID);
      for (var key of Object.keys(this.serviceUserID)) {
        this.currentItem.sale_name = [
          ...this.currentItem.sale_name,
          ...this.serviceUserID[key],
        ];
      }

      this.$set(this.currentItem, "sale_name", [
        ...new Set(this.currentItem.sale_name.map((item) => item)),
      ]);

      this.$forceUpdate();

      this.$bvModal.hide("modal-add-sale");
    },
    camelCaseText(e) {
      return camelCase(e);
    },
    ...mapActions("masterData", [
      "fetchCompany",
      "fetchSaler",
      "fetchServiceTypes",
      "fetchVip",
    ]),
    handSearch() {
      if (this.searchQuery) {
        this.$loading.show();
        this.fetchUser();
      }
    },
    fetchUser: function () {
      useJwt
        .get("userList", {
          params: {
            search: this.searchQuery.trim().trim(),
            page: this.currentPage,
            pageSize: this.perPage,
            status: 0,
          },
        })
        .then((response) => {
          this.items = response.data.result;
          this.totalRows = response.data.meta.total;
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$i18n.t("error"),
              text: this.$i18n.t("errorSystem"),
              icon: "XIcon",
              variant: "danger",
            },
          });
        })
        .finally(() => this.$loading.hide());
    },
    Edit(item) {
      this.currentItem = {
        companyFastId: "",
        companyTmsId: "",
      };
      this.currentItem.org_company_address = item.org_company_address;
      this.currentItem.org_company_name = item.org_company_name;
      this.currentItem.org_tax_code = item.org_tax_code;
      this.currentItem.company_name = this.companyItems.find(
        (e) => e.tax_code == item.org_tax_code
      );
      this.currentItem.companyTmsId =
        this.companyItems.find((e) => e.tax_code == item.org_tax_code)
          ?.tms_id || "";
      this.currentItem.companyFastId =
        this.companyItems.find((e) => e.tax_code == item.org_tax_code)
          ?.fast_id || "";
      this.currentItem.full_name = item.full_name;
      this.currentItem.gender_id = item.gender_id;
      this.currentItem.phone = item.phone;
      this.currentItem.email = item.email;
      this.currentItem.sale_name = item.user_sale_id
        ? this.sales.find((e) => e.id == item.user_sale_id)
        : this.sales.find((e) => e.id == this.userData.username);

      this.currentItem.id = item.id;
      this.currentItem.user_id = item.user_id;
      this.currentItem.customerLevelId = this.vip_types.find(
        (e) => e.id == item.customer_level_id
      );
      
      this.modal_title = this.$i18n.t("approveRegister");
      this.$bvModal.show("modal-edit");
    },
    async Delete(item, index, button) {
      this.currentItem = item;
      var res = await this.$bvModal.msgBoxConfirm(
        this.$i18n.t("areYouDelete") + "?",
        {
          title: this.$i18n.t("deleteRegister"),
          size: "sm",
          okTitle: this.$i18n.t("ok"),
          cancelTitle: this.$i18n.t("cancel"),
        }
      );
      if (res) {
        useJwt
          .delete(`approveReg`, { params: { id: item.id } })
          .then((response) => {
            this.fetchUser();
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$i18n.t("success"),
                text: this.$i18n.t("successfullyDeleted"),
                icon: "CheckSquareIcon",
                variant: "primary",
              },
            });
          })
          .catch((error) => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$i18n.t("error"),
                text: this.$i18n.t("errorSystem"),
                icon: "XIcon",
                variant: "danger",
              },
            });
          });
      }
    },
    async handleOk(bvModalEvt) {
      this.$loading.show();
      bvModalEvt.preventDefault();
      var validate = await this.$refs.simpleRules.validate().then((success) => {
        return success;
      });
      if (!validate) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$i18n.t("error"),
            text: this.$i18n.t("notifyFormError"),
            icon: "XIcon",
            variant: "danger",
          },
        });
        this.$loading.hide();
        return;
      }
      if (this.modal_title == this.$i18n.t("approveRegister")) {
        const service = {};
        for (var key of Object.keys(this.serviceUserID)) {
          // this.currentItem.sale_name = [
          //   ...this.currentItem.sale_name,
          //   ...this.serviceUserID[key],
          // ];
          service[key] = this.serviceUserID[key].map((e) => e.id).toString();
        }

        const data = {
          email: this.currentItem.email.trim().toLowerCase(),
          fullName: this.currentItem.full_name.trim(),
          genderId: this.currentItem.gender_id,
          id: this.currentItem.user_id.toLowerCase(),
          idUserList: this.currentItem.id,
          phone: this.currentItem.phone.trim(),
          taxCode: this.currentItem.company_name.code.trim(),
          userSaleId: JSON.stringify(service).toString(),
          fastId: this.currentItem.companyFastId,
          companyTmsId: this.currentItem.companyTmsId,
          customerLevelId: this.currentItem.customerLevelId?.id,
        };

        useJwt
          .post(`approveReg`, data)
          .then((response) => {
            if (response.data.result == "accExists") {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: this.$i18n.t("error"),
                  text: this.$i18n.t("accExist"),
                  icon: "XIcon",
                  variant: "danger",
                },
              });
            } else if (response.data.result == "emailExists") {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: this.$i18n.t("error"),
                  text: this.$i18n.t("emailExist"),
                  icon: "XIcon",
                  variant: "danger",
                },
              });
            } else {
              this.fetchUser();
              this.$bvModal.hide("modal-edit");
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: this.$i18n.t("success"),
                  text: this.$i18n.t("Successfully Approved"),
                  icon: "CheckSquareIcon",
                  variant: "primary",
                },
              });
            }
          })
          .catch((error) => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$i18n.t("error"),
                text: this.$i18n.t("errorSystem"),
                icon: "XIcon",
                variant: "danger",
              },
            });
          })
          .finally(() => {
            this.$loading.hide();
          });
      }
    },
    addNewCompany() {
      if (!this.currentItem.org_tax_code) {
        return;
      }
      this.$bvModal.hide("modal-edit");

      const data = {
        tax_code: this.currentItem.org_tax_code,
        name: this.currentItem.org_company_name,
        name_vi: this.currentItem.org_company_name,
        fast_id: 0,
        tms_id: 0,
        address: this.currentItem.org_company_address,
        address_vi: this.currentItem.org_company_address,

        acronym: this.currentItem.org_company_name,
      };
      useJwt
        .post("masterData?objectType=Company", data)
        .then(async (response) => {
          if (response.data.result == "exists") {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$i18n.t("error"),
                text: this.$i18n.t("companyAlreadyExists"),
                icon: "XIcon",
                variant: "danger",
              },
            });
          } else {
            const res = await this.fetchCompany();
            this.Edit(this.currentItem);
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$i18n.t("success"),
                text: this.$i18n.t("successfullyAdded"),
                icon: "CheckSquareIcon",
                variant: "primary",
              },
            });
          }
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$i18n.t("error"),
              text: this.$i18n.t("errorSystem"),
              icon: "XIcon",
              variant: "danger",
            },
          });
        });
    },
  },

  data() {
    return {
      dataDemo: [
        {
          rn: 2,
          id: "annt@wr1.com.vn",
          text: "An Nguyen",
          code: "annt@wr1.com.vn",
          name: "An Nguyen",
          fast_id: "",
        },
        {
          rn: 3,
          id: "sale7.hp",
          text: "Anh Nguyen",
          code: "sale7.hp",
          name: "Anh Nguyen",
          fast_id: "",
        },
        {
          rn: 4,
          id: "cuongnh@wr1.com.vn",
          text: "Cuong Nguyen",
          code: "cuongnh@wr1.com.vn",
          name: "Cuong Nguyen",
          fast_id: "CT0057",
        },
        {
          rn: 5,
          id: "msthuydang",
          text: "DANG THI THUY",
          code: "msthuydang",
          name: "DANG THI THUY",
          fast_id: "",
        },
      ],
      serviceUserID: {},
      services: [],
      userData: JSON.parse(localStorage.getItem("userData")),
      items: [],
      perPageOptions: [10, 25, 50, 100],
      perPage: 10,
      currentPage: 1,
      totalRows: 0,
      searchQuery: "",
      modal_title: "",
      genders: this.$Utils.CONSTANTS.GENDER_A,
      currentItem: {},

      isLoading: false,
      fields: [
        {
          key: "created_date",
          sortable: true,
          label: this.$i18n.t("date"),
          class: "maxw-100",
        },
        {
          key: "org_company_name",
          sortable: false,
          label: this.$i18n.t("companyName"),
        },
        {
          key: "full_name",
          label: this.$i18n.t("contactName"),
          sortable: false,
        },
        {
          key: "phone",
          label: this.$i18n.t("phone"),
          sortable: false,
        },
        {
          key: "email",
          label: this.$i18n.t("email"),
          sortable: false,
        },
        {
          key: "creator",
          sortable: false,
          label: this.$i18n.t("creator"),
        },

        {
          key: "actions",
          label: this.$i18n.t("actions"),
          thClass: "text-center",
          tdClass: "actions-td",
        },
      ],
    };
  },
  beforeDestroy() {
    this.$store.commit("masterData/RESET_STATE");
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

.status-witing {
  background: rgba(254, 224, 0, 0.33);
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 1px;
  padding-bottom: 1px;
  border-radius: 50rem;
  font-weight: 600;
  color: #fab318;
}
.swal2-styled.swal2-confirm {
  padding: 10px 50px;
  background-color: #2b938c !important;
}
</style>
